import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6eab38ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = ["onClick", "disabled"]
const _hoisted_3 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = ["placeholder", "disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "add", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "form-text text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (label, idx) => {
        return (_openBlock(), _createElementBlock("span", {
          key: idx,
          class: "badge bg-primary me-2"
        }, [
          _createTextVNode(_toDisplayString(label) + " ", 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-link text-white ms-1 p-0 align-baseline",
            onClick: ($event: any) => (_ctx.remove(idx)),
            disabled: _ctx.disabled
          }, " × ", 8, _hoisted_2)
        ]))
      }), 128)),
      (!_ctx.modelValue || _ctx.modelValue.length === 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('noLabels')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control flex-grow-1",
        placeholder: _ctx.placeholder || _ctx.$t('addLabel'),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newLabel) = $event)),
        disabled: _ctx.disabled,
        onKeyup: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args)), ["prevent"]), ["enter"]))
      }, null, 40, _hoisted_5), [
        [_vModelText, _ctx.newLabel]
      ]),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass('btn btn-icon btn-primary ms-2'),
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args))),
        disabled: _ctx.disabled || !_ctx.newLabel
      }, _hoisted_8, 8, _hoisted_6)
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ]))
}